var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRefresh(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_633_11565)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3.58661 10.6841C4.31076 5.76306 8.88705 2.36083 13.8081 3.08498C15.487 3.33203 17.062 4.04842 18.3516 5.15163L17.1907 6.31251C16.8016 6.7017 16.8017 7.33267 17.1909 7.72176C17.3777 7.90851 17.6311 8.01347 17.8952 8.01351H22.4651C23.0154 8.01351 23.4616 7.56739 23.4616 7.01705V2.44715C23.4614 1.89681 23.0152 1.45077 22.4649 1.45087C22.2007 1.45091 21.9474 1.55587 21.7606 1.74262L20.4651 3.03803C15.525 -1.36557 7.95042 -0.930701 3.54681 4.00937C1.98674 5.75947 0.974339 7.92878 0.635035 10.2486C0.501257 11.071 1.05949 11.8462 1.88187 11.98C1.95595 11.992 2.03078 11.9985 2.10585 11.9994C2.85826 11.9913 3.48982 11.4303 3.58661 10.6841Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.8945 11.9994C22.1421 12.0076 21.5105 12.5686 21.4138 13.3148C20.6896 18.2358 16.1133 21.6381 11.1923 20.9139C9.51334 20.6669 7.93837 19.9505 6.64879 18.8473L7.80968 17.6864C8.19878 17.2972 8.19868 16.6663 7.80945 16.2772C7.62265 16.0904 7.3693 15.9855 7.10515 15.9854H2.53535C1.98501 15.9854 1.53888 16.4315 1.53888 16.9819V21.5518C1.53902 22.1021 1.98524 22.5482 2.53558 22.5481C2.79973 22.548 3.05308 22.4431 3.23988 22.2563L4.53529 20.9609C9.4742 25.365 17.0482 24.9314 21.4523 19.9925C23.0133 18.242 24.0261 16.072 24.3653 13.7513C24.4997 12.929 23.9419 12.1534 23.1197 12.0191C23.0452 12.0069 22.97 12.0003 22.8945 11.9994Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_633_11565"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white",
    transform: "translate(0.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRefresh);
export default __webpack_public_path__ + "static/media/refresh.85f7b8dfd3de5d7f4dc1e2f138b18ce3.svg";
export { ForwardRef as ReactComponent };